import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => {
  return {
    gridContainer: {
      marginBottom: 5,
    },
  };
});
